const isInternetExplorer11 = () => !!window.MSInputMethodContext && !!document.documentMode;

export { isInternetExplorer11 as i };
